module.exports = __webpack_public_path__ + "img/money_white.524213e5.png";